import Cookie from 'common/services/util/-RFC.Cookie';
import eventManager from 'common/services/-RFC.eventManager';

/**
 * @ngdoc directive
 * @name controllers.Register
 * @description
 * Register controller for anonymous user.
 */

angular.module('controllers')
    .controller(
        'RegisterModal',
        (
            $rootScope, $scope,
            $stateParams, Auth,
        ) => {

            if ($stateParams.service) {

                $scope.service = $stateParams.service;

            }
            $scope.next = $stateParams.next;
            if ($scope.next && $scope.next.indexOf('deploy') >= 0 && !$scope.service) {

                $scope.deploy = true;

            }

            $scope.loginHandler = eventManager.subscribe('auth:login', (userData) => {

                const User = {};

                Auth.clearSession();
                Auth.removeLoginCookies();
                Auth.setLoginCookies(userData);
                Auth.request = true;

                User.id = userData.u;
                User.deferred.resolve(userData);
                $rootScope.State.deviceId = null;
                if (userData.newdid) {

                    $rootScope.State.deviceId = userData.newdid;

                }

            });

            // Unbind the login handler when the scope is destroyed
            $scope.$on('$destroy', () => {

                $scope.loginHandler();

            });

            // if user closes the popup by clicking outside
            // store input values in cookies
            $scope.$on('inputData', (event, inputData) => {

                const currentModal = $stateParams.ltb;

                $scope.saveData = () => {

                    if (currentModal === 'register' &&
                    !Cookie.get('used_anonForm_reg')) {

                        Cookie.set('user_fullname', inputData.fullName, { path: '/' });
                        Cookie.set('user_email', inputData.email, { path: '/' });
                        Cookie.set('saved_reg', true, { path: '/' });

                    } else if (currentModal === 'login' &&
                    !Cookie.get('used_anonForm_login')) {

                        Cookie.set('user_email', inputData.email, { path: '/' });
                        Cookie.set('saved_login', true, { path: '/' });

                    }

                };

                // add data from cookies to input fields
                if (Cookie.get('saved_reg') && currentModal === 'register') {

                    inputData.fullName = Cookie.get('user_fullname');
                    inputData.email = Cookie.get('user_email');
                    Cookie.set('used_anonForm_reg', true, { path: '/' });

                } else if (Cookie.get('saved_login') && currentModal === 'login') {

                    inputData.email = Cookie.get('user_email');
                    Cookie.set('used_anonForm_login', true, { path: '/' });

                }

                Cookie.remove('user_fullname', { path: '/' });
                Cookie.remove('user_email', { path: '/' });
                Cookie.remove('saved_reg', { path: '/' });
                Cookie.remove('saved_login', { path: '/' });

            });

        },
    );



// WEBPACK FOOTER //
// ./scripts/controllers/modals/register.js